import React from 'react'

import { UseDisclosureReturn } from '@chakra-ui/react'

type HeaderContextType = {
  setMiddleContent: React.Dispatch<React.SetStateAction<React.ReactNode>>
  middleContent: React.ReactNode
  referralModalDisclosure: UseDisclosureReturn
}
export const HeaderContext = React.createContext<HeaderContextType>(
  {} as HeaderContextType,
)
